export default __webpack_public_path__ + "img/7752e5f19ce2a9bb106424c7d4349f0c.png";